import "./Aser.css";
import { useEffect } from "react";
import aservideo from "../../assets/aser.mp4";
import TerminalCard from "../../components/TerminalCard/TerminalCard";
import LogoLoop from "../LogoLoop/LogoLoop";
import anthropic from "../../assets/logos/anthropic.svg";
import bluesky from "../../assets/logos/bluesky.svg";
import chroma from "../../assets/logos/chroma.svg";
import coinmarketcap from "../../assets/logos/coinmarketcap.svg";
import deepseek from "../../assets/logos/deepseek.svg";
import defillama from "../../assets/logos/defillama.svg";
import discord from "../../assets/logos/discord.svg";
import exa from "../../assets/logos/exa.svg";
import farcaster from "../../assets/logos/farcaster.svg";
import gemini from "../../assets/logos/gemini.svg";
import goplus from "../../assets/logos/goplus.svg";
import grok from "../../assets/logos/grok.svg";
import mastodon from "../../assets/logos/mastodon.svg";
import openai from "../../assets/logos/openai.svg";
import pancake from "../../assets/logos/pancake.svg";
import supabase from "../../assets/logos/supabase.svg";
import telegram from "../../assets/logos/telegram.svg";
import twitter from "../../assets/logos/twitter.svg";
import web3bio from "../../assets/logos/web3bio.svg";
import deepgram from "../../assets/logos/deepgram.svg";
import CodeCard from "../../components/CodeCard/CodeCard";
function Aser() {
  const infras = [
    { src: openai, alt: "OpenAI" },
    { src: anthropic, alt: "Anthropic" },
    { src: grok, alt: "Grok" },
    { src: gemini, alt: "Gemini" },
    { src: deepseek, alt: "DeepSeek" },
    { src: chroma, alt: "Chroma" },
    { src: exa, alt: "Exa" },
    { src: deepgram, alt: "DeepGram" },
    { src: supabase, alt: "Supabase" },
  ];
  const social = [
    { src: twitter, alt: "Twitter" },
    { src: farcaster, alt: "Farcaster" },
    { src: telegram, alt: "Telegram" },
    { src: discord, alt: "Discord" },
    { src: mastodon, alt: "Mastodon" },
    { src: bluesky, alt: "Bluesky" },
  ];
  const apps = [
    { src: coinmarketcap, alt: "CoinMarketCap" },
    { src: defillama, alt: "DefiLlama" },
    { src: goplus, alt: "GoPlus" },
    { src: pancake, alt: "Pancake" },
    { src: web3bio, alt: "Web3Bio" },
  ];
  return (
    <div className="Aser">
      <div className="AserTitle">Aser Agent</div>
      <div className="AserContainer">
        <div className="AserCard">
          <video autoPlay loop muted playsInline className="AserVideo">
            <source src={aservideo} type="video/mp4" />
          </video>

          <div className="AserRightCard">
            <div className="AserIntroduce">
              Aser is equipped with standardized AI capability middleware, such
              as knowledge, memory, tracing, thinking, API interfaces, and
              social clients. By dynamically integrating Web3 toolkits, it helps
              developers quickly build and launch AI agents with native Web3
              capabilities.
            </div>

            <div className="AserBtn">
              <a href="https://github.com/AmeNetwork/aser" target="_blank">
                <div className="AserLearnMore">Learn More</div>
              </a>
              <div className="AserGithub">
                <iframe
                  src="https://ghbtns.com/github-btn.html?user=AmeNetwork&repo=aser&type=star&count=true&size=large"
                  frameborder="0"
                  width="170"
                  height="30"
                  title="GitHub"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className="AserDetail">
          <div className="AserInstall">
            <p className="AserInstallTitle">Install</p>
            <p className="AserInstallContent">
              Start in seconds with a single-line command
            </p>
            <TerminalCard></TerminalCard>
            <p className="AserInstallTitle" style={{ marginTop: "30px" }}>
              Simple to implement
            </p>
            <p className="AserInstallContent">
              Only a few lines of code build the future of AI Agent
            </p>
            <CodeCard></CodeCard>
          </div>
          <div className="AserIntegration">
            <div className="AserIntegrateTitle">Integrations</div>
            <div className="AserIntegrateContent">
              Aser integrates core services across multiple fields, provides a
              wealth of pre-built toolkits, and enables an almost zero-friction
              setup.
            </div>
            <div className="AserIntegrateList">
              <LogoLoop
                logos={infras}
                speed={100}
                direction="left"
                logoHeight={32}
                gap={40}
                pauseOnHover
                scaleOnHover
                fadeOut
                fadeOutColor="#111111"
                style={{ marginBottom: "60px" }}
              />

              <LogoLoop
                logos={apps}
                speed={80}
                direction="right"
                logoHeight={32}
                gap={40}
                pauseOnHover
                scaleOnHover
                fadeOut
                fadeOutColor="#111111"
                style={{ marginBottom: "60px" }}
              />
              <LogoLoop
                logos={social}
                speed={100}
                direction="right"
                logoHeight={32}
                gap={40}
                pauseOnHover
                scaleOnHover
                fadeOut
                fadeOutColor="#111111"
                style={{ marginBottom: "30px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aser;
